// Curated set of hex colors admins can pick from for a prompt template
// group. Plain hex values only — CSS custom properties like
// var(--oliver-accent) are scoped to the Oliver chat widget's own DOM
// subtree and won't resolve anywhere else (this admin page included).
// Keep in sync with crm-api's App\PromptTemplates\PromptGroupColorRegistry.
export const DEFAULT_GROUP_COLOR = "#0d9488";

export const GROUP_COLOR_OPTIONS = [
  { value: DEFAULT_GROUP_COLOR, label: "Teal" },
  { value: "#d97706", label: "Amber" },
  { value: "#2563eb", label: "Blue" },
  { value: "#e11d48", label: "Rose" },
  { value: "#16a34a", label: "Green" },
  { value: "#7c3aed", label: "Violet" },
  { value: "#0891b2", label: "Cyan" },
  { value: "#db2777", label: "Pink" },
  { value: "#ea580c", label: "Orange" },
  { value: "#4f46e5", label: "Indigo" },
  { value: "#ca8a04", label: "Yellow" },
  { value: "#475569", label: "Slate" },
];
